<template>
  <div class="exam-card-comp">
    <div class="header">
      <div class="title">
        <span class="tag" :class="[calcStatus(exam.status)]">{{ exam.status }}</span>
      </div>
      <dropdown-menu menu="更多操作" menu-type="span" @action="handleAction" :drop-down-items="dropDownItems">
        <template #menu>...</template>
      </dropdown-menu>
    </div>

    <div class="main" @click.prevent="navToExamSummary">
      <img src="../assets/img_exam_flag@2x.png" />

      <div class="title">
        {{ exam.title }}
      </div>
    </div>

    <div class="info-box" @click.prevent="navToExamSummary">
      <div class="item">
        <div class="label">布置班级</div>
        <div class="value">{{ exam.clazzName }}</div>
      </div>
      <div class="item">
        <div class="label">考试时间</div>
        <div class="value">{{ exam.date }}</div>
      </div>

      <div class="item">
        <div class="label">布置教师</div>
        <div class="value">{{ exam.creator }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Emit, Prop } from 'kuaidong-component'
import { ToastDebug } from 'kuaidong-lib'
import { FileExportService } from 'kuaidong-service'
import { AWinter2023 } from 'kuaidong-api'
import DropdownMenu from '@/components/StudentManagement/DropdownMenu.vue'
@Component({
  components: {
    DropdownMenu,
  },
})
export default class ExamCard extends BaseComponent {
  @Prop({ type: Object, required: true })
  exam!: {
    online_exam_id: string
    title: string
    status: string
    clazzName: string
    date: string
    creator: string
  }

  actionVisible = false

  get isUnStart() {
    return this.exam.status === '未开始'
  }

  get isEnd() {
    return this.exam.status === '已结束'
  }

  get dropDownItems() {
    const items: {
      label: string
      action: string
      type?: 'dangerous' | 'text'
    }[] = []
    if (this.isUnStart) {
      items.push({
        label: '修改名称',
        action: 'changeName',
        type: 'text',
      })

      items.push({
        label: '调整时间',
        action: 'updateTime',
        type: 'text',
      })
    }

    if (this.isEnd) {
      items.push({
        label: '下载数据',
        action: 'download',
        type: 'text',
      })
    }

    items.push({
      label: '删除',
      action: 'remove',
      type: 'dangerous',
    })
    return items
  }

  calcStatus(status: string) {
    if (status === '未开始') {
      return 'un-start'
    } else if (status === '进行中') {
      return 'progress'
    } else {
      return 'end'
    }
  }
  handleAction(actionInfo: { action: string; row: any }) {
    if (actionInfo.action === 'remove') {
      this.handleRemove()
    }
    if (actionInfo.action === 'changeName') {
      this.changeName()
    }
    if (actionInfo.action === 'updateTime') {
      this.showUpdatePopup()
    }
    if (actionInfo.action === 'download') {
      this.download()
    }
  }

  @ToastDebug()
  viewPractice() {
    return
  }

  @Emit('updateName')
  changeName() {
    this.actionVisible = false
    return this.exam
  }

  @Emit('updateTime')
  showUpdatePopup() {
    this.actionVisible = false
    return this.exam
  }
  async download() {
    this.actionVisible = false
    FileExportService.exportFile(AWinter2023.exportExam, this.exam.online_exam_id)()
  }

  @Emit('remove')
  handleRemove() {
    this.actionVisible = false
    return this.exam
  }

  @Emit('navToExamSummary')
  navToExamSummary() {
    return this.exam
  }
}
</script>
<style lang="less">
.exam-card-comp {
  width: 272px;
  height: 274px;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  > .header {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(180deg, rgba(75, 206, 143, 0.05) 0%, rgba(75, 206, 143, 0) 100%);
    > .title {
      > .tag {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;

        &.un-start {
          color: #fe9647;
        }
        &.progress {
          color: var(--shs-theme-primary);
        }
        &.end {
          color: #81848f;
        }
      }
    }
    > .dropdown-menu-comp {
      height: 25px;

      > span {
        color: #c7c9d1;
        letter-spacing: 2px;
      }
    }
  }
  > .main {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    > img {
      width: 60px;
      height: 70px;
      margin: 0 auto;
    }

    > .title {
      margin-top: 18px;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      text-align: center;
      color: #0a1629;
      height: 46px;
      padding: 0 16px;
      box-sizing: border-box;
    }
  }

  > .info-box {
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px;
    background: #fff;
    border-radius: 8px;
    cursor: pointer;
    > .item {
      display: flex;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #8f8f8f;
      margin-top: 8px;
      > .label {
        margin-right: 12px;
      }
    }
  }
}
</style>
